<mat-sidenav-container class="sidenav-container">
  <mat-sidenav
    class="sidebar-nav"
    [mode]="showSidebar() && matSidenav()?.opened ? 'side' : 'over'"
    [opened]="showSidebar()"
  >
    <app-sidebar></app-sidebar>
  </mat-sidenav>
  <mat-sidenav-content>
    <app-header (toggleSidebarOutput)="toggleSidebar()"></app-header>
    <main class="app-shell__content">
      <router-outlet></router-outlet>
    </main>
  </mat-sidenav-content>
</mat-sidenav-container>

@if (loading.isLoading()) {
  <sci-loader mode="screen" size="lg" [label]="loading.message() ?? 'components.loader.label' | translate" />
}
